import { createFileRoute } from "@tanstack/react-router";

import { Dataset } from "./-dataset";
import { parseDatasetSearch } from "../../../workspaces/library/pages/dataset-search";

export const Route = createFileRoute(
  "/_console/p/$org/$project/library/datasets/$name/",
)({
  validateSearch: parseDatasetSearch,
  component: DatasetRoute,
});

/* The dataset name is the address, with no segment opened. Reading it here keeps the
 * screen a plain component of what it is showing, which is also how the smoke suite can
 * mount it. */
function DatasetRoute() {
  const { name } = Route.useParams();
  return <Dataset name={name} state={Route.useSearch()} />;
}
